import axios from 'axios'

export default {
    getBadges: () => axios.get(`/order`),
    getAllNew: () => axios.get(`/order?filter=new`),
    getAllInProgress: () => axios.get(`/order?filter=in_progress`),
    getAllEnded: () => axios.get(`/order?filter=ended`),
    getById: orderId => axios.get(`/order/${orderId}`),
    edit: formData => axios.put(`/order/edit`, formData),
    getDetails: orderId => axios.get(`/order/details/${orderId}`),
    searchById: formData => axios.post(`/order/search`, formData)
}
